import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import './LoadingScreen.scss';

const LoadingScreen = ({ overlayStyles = {} }) => (
    <>
        <div id='spinner-overlay' style={overlayStyles} />
        <div id='spinner-icon-cont'>
            <CircularProgress color='secondary' size={65} />
        </div>
    </>
);

LoadingScreen.propTypes = {
    overlayStyles: PropTypes.object,
};

export default LoadingScreen;
